// models/snippets-view.model.ts
export interface SnippetsViewModel {
  dateCreated: Date;
  dateLastModified: Date;
  staffId: string;
  snippetGuid: string;
  snippetTitle: string;
  snippetNote: string;
  snippetBody: string;
  snippetBodyPlainText: string;
  snippetBodyType: SnippetBodyType;
  sharedSnippet: number;
  praSysId?: number;
  templateSysId: number;
  name: string;
  initials: string;
  title: string;
  selector: string;
  fileName: string;
  displayTitle: string;
  area: string;
}

export enum SnippetBodyType {
  RawText = 0,
  HTML = 1,
  RTF = 2,
}
